<footer id="footer">
    <div class="container container-lp">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-top">
                    <div class="row">

                        <div class="col-lg-6">
                            <div class="about-enago">
                                <h2>About Trinka</h2>
                                <p class="commonAboutContent">
                                  <span>Trinka AI is a privacy-first <a href="/grammar-checker" class="text-link">grammar checker</a> and language enhancement writing assistant designed for academic and technical writing. Trinka helps professionals and academics ensure formal, concise, and engaging writing. Trinka's Enterprise solutions come with full access, multiple integration options, and complete data control, which can be customized to fit your needs.</span>
                                </p>
                                <p class="nosnipptAboutContent">
                                    <span data-nosnippet>Trinka AI is a privacy-first <a href="/grammar-checker" class="text-link">grammar checker</a> and language enhancement writing assistant designed for academic and technical writing. Trinka helps professionals and academics ensure formal, concise, and engaging writing. Trinka's Enterprise solutions come with full access, multiple integration options, and complete data control, which can be customized to fit your needs.</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="footer-widget">
                                <h2>Install for:</h2>
                                <ul class="install-for">
                                    <li>
                                        <div class="install-in-browser">
                                            <a href="/wordplugin">
                                                <div class="icon text-center">
                                                    <img src="assets/images/NewWordAdd_in.svg" width="47" height="42" alt="" />
                                                </div>
                                                <span>MS Word for Windows</span>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="install-in-browser">
                                            <a href="/browser-plugin">
                                                <div class="icon text-center">
                                                    <img src="assets/images/NewChromeFicon.svg" width="43" height="42" alt="" />
                                                </div>
                                                <span>Google Chrome</span>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="install-in-browser">
                                            <a href="/browser-plugin">
                                                <div class="icon text-center">
                                                    <img src="assets/images/NewFirefoxFicon.svg" width="42" height="42" alt="" />
                                                </div>
                                                <span>Mozilla Firefox</span>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="install-in-browser">
                                            <a href="/browser-plugin">
                                                <div class="icon text-center">
                                                    <img src="assets/images/EdgeWhite_BGAndOutline.svg" width="42" height="42" alt="" />
                                                </div>
                                                <span>Microsoft Edge</span>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="install-in-browser">
                                            <a href="/wordplugin-lite">
                                                <div class="icon text-center">
                                                    <img src="assets/images/NewWordAdd_in.svg" width="47" height="42" alt="" />
                                                </div>
                                                <span>MS Word for Mac OS</span>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="install-in-browser">
                                            <a href="/windows-desktop-app">
                                                <div class="icon text-center">
                                                    <img src="assets/images/windows.png" width="42" height="42" alt="" />
                                                </div>
                                                <span>Windows App</span>
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="contact" id="footerEmailBox">
                                <form class="form-inline" (ngSubmit)="subscribeNow()" [formGroup]="footerFroms">
                                    <div class="form-group mx-sm-3 mb-2 ml-0" [ngClass]="(!footerFroms.get('footeremailform').valid && footerFroms.get('footeremailform').dirty) || (footerFroms.get('footeremailform').touched && footerFroms.get('footeremailform').pristine) ? 'TextFiledError' : '' ">

                                        <mat-form-field appearance="outline">
                                            <mat-label>
                                                <span class="desktop-label">Enter email &amp; click subscribe to get updates</span>
                                                <span class="mobile-label">Enter your email for updates</span>
                                            </mat-label>
                                            <input matInput placeholder="" formControlName="footeremailform" class="form-control" name="email">
                                        </mat-form-field>
                                    </div>
                                    <button type="submit" [disabled]="!footerFroms.valid" id="footerSubscribe" class="btn btn-primary mb-2">Subscribe</button>
                                </form>
                            </div>

                        </div>


                    </div>
                    <div class="row">

                        <div class="col-lg-12">
                            <div class="row footer_menu_wrap">
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h2>Company</h2>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a href="/aboutus">About Us</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/contactus']" routerLinkActive="active">Contact Us</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/workwithus']" routerLinkActive="active">Work With Us</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/affiliates']" routerLinkActive="active">Affiliate Program</a>
                                            </li>
                                            <li>
                                                <a href="/campus-ambassador">Ambassador Program</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/news']" routerLinkActive="active">News</a>
                                            </li>
                                            <li>
                                                <a href="/trust-center" routerLinkActive="active">Trust Center</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="footer_menu_one">
                                        <h2>Learn More</h2>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/examples']" routerLinkActive="active">Examples</a>
                                            </li>
                                            <li>
                                                <a href="/faqs">FAQs</a>
                                            </li>
                                            <li>
                                                <a href="https://developer.trinka.ai/docs/getting-started" target="_blank" rel="noopener noreferrer">Developer Docs</a>
                                            </li>
                                            <li>
                                                <a href="/eu-ai-act-compliance">EU AI Act Compliance</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h2>Features</h2>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/features']">All Features</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/grammar-checker']">Correct Your Grammar</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/proofread-file']">Proofread MS Word File</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/latex-grammar-checker']">LaTeX Proofreader</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/translation']">Translation</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/paraphraser']">Online Paraphraser </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/ai-studio/ai-writing-tools']">AI Writing Tools</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/ai-studio/ai-assisted-writing']">AI-assisted Writing</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/consistency-check']">Consistency Check</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/inclusive-language-check']">Inclusive Language Check</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/features/documark']">Documark</a>
                                            </li> -->
                                            <li>
                                                <a [routerLink]="['/features/plagiarism-check']">Plagiarism Check</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/ai-content-detector']" aria-label="AI Detector Features">AI Detector</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/technical-checks']">Technical Checks</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/citation-checker']">Citation Checker</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/citation-formatter']">Citation Formatter</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/journal-finder']">Journal Finder</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/legal-writing']">Legal Writing</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/personal-dictionary']">Personal Dictionary</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/credits']">Credits on Trinka</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/certificate-of-editing']">Certificate of Editing</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h2>Enterprise Solutions</h2>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/features/documark']">DocuMark</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">Life Sciences, Medicine & Pharma</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">Language Services, Publishing & Media</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">Academic Institutions</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">K-12 & E-Learning</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">Technology Platforms</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/confidential-data-plan-for-grammar-checker']" routerLinkActive="active">Confidential Data Plan</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Enterprise Integrations</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">Grammar Checker API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/local-invoice']" routerLinkActive="active">Invoicing and Payments</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/windows-desktop-app/offline-grammar-checker']" routerLinkActive="active">Offline Grammar Checker</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka On-Premise</a>
                                            </li> -->


                                        </ul>
                                    </div>
                                    <div class="footer_menu_one">
                                        <h2>Custom AI Models</h2>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/overview']">Overview</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/how-we-do-it']">How We Do It</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/process']">Process</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/why-choose-us']">Why Choose Us</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/custom-ai-models/rlhf']"> Reinforcement Learning with <br/>Human Feedback (RLHF)</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="row">
                                        <div class="col-sm-6 col-6">
                                            <div class="footer_menu_one">
                                                <h2>Compare</h2>
                                                <ul class="ftr-menu">
                                                    <li>
                                                        <a href="/trinka-vs-grammarly">Trinka vs. Grammarly</a>
                                                    </li>
                                                    <li>
                                                        <a href="/trinka-vs-ginger">Trinka vs. Ginger</a>
                                                    </li>
                                                    <li>
                                                        <a href="/trinka-vs-languagetool">Trinka vs. LanguageTool</a>
                                                    </li>
                                                    <li>
                                                        <a href="/trinka-vs-writefull">Trinka vs. Writefull</a>
                                                    </li>
                                                    <li>
                                                        <a href="/trinka-vs-quillbot">Trinka vs. Quillbot</a>
                                                    </li>
                                                    <li>
                                                        <a href="/trinka-vs-zerogpt">Trinka vs. ZeroGPT</a>
                                                    </li>
                                                    <li>
                                                        <a href="/trinka-vs-prowritingaid">Trinka vs. ProWritingAid</a>
                                                    </li>
                                                    <li>
                                                        <a href="/trinka-vs-gptzero">Trinka vs. GPTZero</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="footer_menu_one">
                                                <h2>Resources</h2>
                                                <ul class="ftr-menu">
                                                    <li>
                                                        <a href="/case-study">Case Study</a>
                                                    </li>
                                                    <li>
                                                        <a href="/industry-engagements">Industry Engagements</a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.trinka.ai/blog/"  target="_blank" rel="noopener">Blog</a>
                                                    </li>
                                                    <li>
                                                        <a href="/webinars">Webinars</a>
                                                    </li>
                                                    <li>
                                                        <a href="podcast" routerLinkActive="active">Podcast</a>
                                                    </li>
                                                    <li>
                                                        <a href="/resources/newsletters">Newsletters</a>
                                                    <li>
                                                        <a href="/videos">Videos</a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.trinka.ai/university-ai-policy-repository" target="_blank">University AI Policy Hub </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                            <div class="footer_menu_one">
                                                <h2>Tools</h2>
                                                <ul class="ftr-menu">
                                                    <li>
                                                        <a href="/grammar-checker">Grammar Checker</a>
                                                        <!-- <a [routerLink]="['/grammar-checker']" routerLinkActive="active">Grammar Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="/spanish-grammar-checker">Spanish Grammar checker</a>
                                                        <!-- <a [routerLink]="['/grammar-checker']" routerLinkActive="active">Grammar Checker</a> -->
                                                    </li>
                                                    <!-- <li>
                                                        <a href="/de/grammatik-pruefen" target="_blank" rel="noopener noreferrer">German Grammar checker</a>
                                                    </li> -->
                                                    <li>
                                                        <a href="/paraphrasing-tool">Paraphrasing Tool</a>
                                                        <!-- <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">Punctuation Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="/journal-finder">Free Journal Finder</a>
                                                        <!-- <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">Punctuation Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="/ai-content-detector" aria-label="AI Detector Tool">AI Detector</a>
                                                        <!-- <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">Punctuation Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="/punctuation-checker">Punctuation Checker</a>
                                                        <!-- <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">Punctuation Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="/spell-checker">Spell Checker</a>
                                                        <!-- <a [routerLink]="['/spell-checker']" routerLinkActive="active">Spell Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="/sentence-checker">Sentence Checker</a>
                                                        <!-- <a [routerLink]="['/sentence-checker']" routerLinkActive="active">Sentence Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="/essay-checker">Essay Checker</a>
                                                    </li>
                                                    <li>
                                                        <a href="/medical-grammar-and-spelling-checker">Medical Grammar Check</a>
                                                    </li>
                                                    <li>
                                                        <a [routerLink]="['/academic-phrasebank']" routerLinkActive="active">Academic Phrasebank</a>
                                                    </li>
                                                    <li>
                                                        <a [routerLink]="['/thesis-checker']" routerLinkActive="active">Thesis Checker</a>
                                                    </li>
                                                    <li>
                                                        <a href="/ai-editing">AI Editing</a>
                                                    </li>
                                                    <li>
                                                        <a [routerLink]="['/free-proofreading-tools']" >AI Proofreading Tools</a>
                                                        <!-- <a [routerLink]="['/grammar-checker']" routerLinkActive="active">Grammar Checker</a> -->
                                                    </li>
                                                    <li>
                                                        <a href="https://www.trinka.ai/es/ia-generativa-academica" target="_blank">Generative AI Course</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-12">
                                            <div class="footer_menu_one">
                                                <h2>Compliances Covered</h2>
                                                <ul class="complianceCovered">
                                                    <li>
                                                        <a href="/trust-center">
                                                            <img src="../../../../assets/images/Hipaa-logo.svg"
                                                                 loading="lazy"
                                                                 decoding="async"
                                                                 width="57"
                                                                 height="57"
                                                                 alt="HIPAA compliance" />
                                                        </a>
                                                    </li>
                                                
                                                    <li>
                                                        <a href="/trust-center">
                                                            <img src="../../../../assets/images/EU_AI_Act.png"
                                                                 loading="lazy"
                                                                 decoding="async"
                                                                 width="57"
                                                                 height="57"
                                                                 alt="EU AI Act compliance" />
                                                        </a>
                                                    </li>
                                                
                                                    <li>
                                                        <a href="/trust-center">
                                                            <img src="../../../../assets/images/SOC-2.webp"
                                                                 loading="lazy"
                                                                 decoding="async"
                                                                 width="57"
                                                                 height="57"
                                                                 alt="AICPA - SOC" />
                                                        </a>
                                                    </li>
                                                
                                                    <li>
                                                        <a href="/trust-center">
                                                            <img src="assets/images/enterprise/data-sensitive/ferpa-logo.webp"
                                                                 loading="lazy"
                                                                 width="113"
                                                                 height="112"
                                                                 alt="FERPA compliance" />
                                                        </a>
                                                    </li>
                                                
                                                    <li>
                                                        <a href="/trust-center">
                                                            <img src="../../../../assets/images/compliance-certificate5.svg"
                                                                 loading="lazy"
                                                                 decoding="async"
                                                                 width="57"
                                                                 height="57"
                                                                 alt="General Data Protection Regulation (GDPR) compliance" />
                                                        </a>
                                                    </li>
                                                
                                                    <li>
                                                        <a href="/trust-center">
                                                            <img src="../../../../assets/images/compliance-certificate1.svg"
                                                                 loading="lazy"
                                                                 decoding="async"
                                                                 width="57"
                                                                 height="57"
                                                                 alt="ISO 27001:2022 Information Security Management System certification" />
                                                        </a>
                                                    </li>
                                                
                                                    <li>
                                                        <a href="/trust-center">
                                                            <img src="../../../../assets/images/compliance-certificate4.svg"
                                                                 loading="lazy"
                                                                 decoding="async"
                                                                 width="57"
                                                                 height="57"
                                                                 alt="ADA accessibility compliance" />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="purple-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>Need any help? Connect with us at
                        <a href="mailto:support&#64;trinka&#46;ai">support&#64;trinka&#46;ai</a>
                    </p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="footer-separator"></div>
    <div class="container container-lp">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-middle">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="powerd-by">
                                <div class="powered-by-left">
                                    <h2>Powered by:</h2>
                                    <p>
                                        <a href="https://www.enago.com/" target="_blank" rel="noopener noreferrer" class="footer_logos">
                                            <img src="../../../assets/images/enago-logo.png" loading="lazy" width="140" height="40" alt="enago logo" class="enago logo" />
                                        </a>
                                    </p>
                                </div>
                                <div class="powered-by-right">
                                    <p>Enago is a trusted name in author services for the global research community helping
                                        researchers in 125+ countries improve the communication of their research and achieve
                                        successful publication.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="footer_menu_one footer_menu_last">
                                <h2>Services Offered</h2>
                                <ul class="ftr-menu">
                                    <li>
                                        <a href="https://www.enago.com/" target="_blank" rel="noopener noreferrer">English Editing</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.com/publication-support-services" target="_blank" rel="noopener noreferrer">Publication Support</a>
                                    </li>
                                    <li>
                                        <a href="https://www.ulatus.com/" target="_blank" rel="noopener noreferrer">Translation Company</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.com/plagiarism-checker/" target="_blank" rel="noopener noreferrer">Plagiarism and Auto Grammar Check</a>
                                    </li>
                                    <li>
                                        <a href="https://www.voxtab.com/" target="_blank" rel="noopener noreferrer">Transcription & Subtitling Services</a>
                                    </li>
                                    <li>
                                        <a href="https://lifesciences.enago.com/" target="_blank" rel="noopener noreferrer">Global Medical Communications</a>
                                    </li>
                                    <li>
                                        <a href="https://www.read.enago.com/" target="_blank" rel="noopener noreferrer">Literature Review & Analysis Tool</a>
                                    </li>
                                    <li>
                                        <a href="https://www.charlesworth-group.com/" target="_blank" rel="noopener noreferrer">Digital Marketing Agency</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-bottom">
                    <div class="row">
                        <div class="col-lg-7 col-md-12">
                            <p>© Crimson AI, {{ latestYear }}. Made in India.</p>
                            <ul class="ftr-menu1">
                                <li>
                                    <a href="mailto:support&#64;trinka&#46;ai">support&#64;trinka&#46;ai</a>
                                </li>
                                <li>
                                    <a id="PrivacyButton" [routerLink]="['/privacypolicy']" routerLinkActive="active">Privacy Policy</a>
                                </li>
                                <li>
                                    <a id="termsofserviceButton" [routerLink]="['/termsofservices']" routerLinkActive="active">Terms of Services</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-5 col-md-12">
                            <div class="follow-us">
                                <h2>Follow Us:</h2>
                                <ul class="social-media">
                                    <li>
                                        <a href="https://www.facebook.com/thetrinkaai/" rel=" no referer, no opener" aria-label="facebook" target="_blank" rel="noopener noreferrer">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/thetrinkaai/" rel=" no referer, no opener" aria-label="instagram" target="_blank" rel="noopener noreferrer">
                                            <i class="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://x.com/thetrinkaai" rel=" no referer, no opener" aria-label="twitter" target="_blank" rel="noopener noreferrer">
                                            <img src="../../../assets/images/twitter-logo.svg" alt="twitter" width="15" height="14" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/thetrinkaai" rel=" no referer, no opener" aria-label="linkedin" target="_blank" rel="noopener noreferrer">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA" rel=" no referer, no opener" aria-label="youtube" target="_blank" rel="noopener noreferrer">
                                            <i class="fa fa-youtube-play"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="language_sections" id="languageDropDown">
                                <i class="fa fa-globe" aria-hidden="true"></i>
                                <span>English</span>
                                <ul class="drop">
                                    <li class="selected">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                                        <a href="https://www.trinka.ai/">English</a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/jp/">
                                            日本語
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/de/">
                                            Deutsch
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://trinka.enago.cn/">
                                            简体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/tw/">
                                            繁體中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/kr/">
                                            한국어
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/es/">
                                            Español
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/pt/">
                                            Português
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div id="emailSubscribePopup" class="modal fade show" *ngIf="subscribePopup">
	<div class="modal-dialog modal-confirm">
		<div class="modal-content" role="status" aria-live="polite" aria-atomic="true">
			<div class="modal-header flex-column">
				<div class="icon-box">
					<i class="material-icons">&#xE5CA;</i>
				</div>						
				<h4 class="modal-title w-100">Thank you for subscribing to our newsletter</h4>	
                <button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="close" data-dismiss="modal" aria-label="Close dialog">&times;</button>
			</div>
			<div class="modal-body">
                <p>Your subscription has been confirmed.</p>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="btn btn-secondary" data-dismiss="modal" aria-label="ok">OK</button>
				<!-- <button type="button" class="btn btn-danger">Delete</button> -->
                <p>Note: If at any point of time you wish to opt out from the newsletters, you can simply click on "Unsubscribe" link at the bottom of newsletter.</p>
			</div>
		</div>
	</div>
</div>